import '../sass/citrus-single-property-images.scss';

(() => {
    const $citrusSinglePropertyImages = document.querySelectorAll('.citrus-single-property-images');

    if (!$citrusSinglePropertyImages) return;

    $citrusSinglePropertyImages.forEach($citrusSinglePropertyImages => {
        const $carousel = $citrusSinglePropertyImages.querySelector('.citrus-single-property-images__carousel');
        const $paginationBullets = $citrusSinglePropertyImages.querySelectorAll('.citrus-single-property-images__pagination-bullet');
        const $navigationNext = $citrusSinglePropertyImages.querySelector('.citrus-single-property-images__navigation--next');
        const $navigationPrev = $citrusSinglePropertyImages.querySelector('.citrus-single-property-images__navigation--prev');

        const initCarousel = () => {
            if (!$carousel) return;

            const carousel = new Swiper($carousel, {
                keyboard: {
                    enabled: true,
                },
                loop: true,
                navigation: {
                    nextEl: $navigationNext ?? null,
                    prevEl: $navigationPrev ?? null,
                },
            });

            if ($paginationBullets) {
                carousel.on('realIndexChange', swiper => {
                    $paginationBullets.forEach(($paginationBullet, index) => {
                        const { activeClasses, inactiveClasses } = $paginationBullet.dataset;
                        
                        $paginationBullet.classList = index === swiper?.realIndex ? activeClasses : inactiveClasses;
                    });
                });
            }
        };

        initCarousel();
    });
})();
